import videojs from 'video.js';

const Component = videojs.getComponent('Component');

function getMaxDelay(count) {
    const maxNumInSec = 10;
    return Math.round(count / maxNumInSec);
}

function animationSettingShake(el, maxDelay) {
    el.style.animationDelay = `animation-delay: ${Math.random() * maxDelay}s, 0s`;
    el.style.animationDuration = `${Math.random() + 1}s, 1.5s`;
}

function animationSettingToSide(el, maxDelay) {
    const duration = Math.random() + 1;
    el.style.animationDuration = `${duration}s, ${duration}s`;
    const delay = Math.random() * maxDelay;
    el.style.animationDelay = `${delay}s`;
}

const animationSettings = [animationSettingShake, animationSettingShake, animationSettingToSide, animationSettingToSide];

class Bubbles extends Component {
    constructor(player, options) {
        super(player, options);
        this.addClass('vjs-likes__bubbles-container');
    }

    create(count = 1) {
        const maxDelay = getMaxDelay(count);
        while(count-- !== 0) {
            const bubbleEl = document.createElement('span');
            const size = `${Math.random() * 40 + 10}px`;
            bubbleEl.classList.add('vjs-likes__bubble');
            bubbleEl.style.cssText = `
                width: ${size};
                height: ${size};
            `;
            const animationIndex = Math.round(Math.random() * (animationSettings.length - 1));
            bubbleEl.classList.add(`vjs-likes__bubble_animation${animationIndex}`);
            animationSettings[animationIndex](bubbleEl, maxDelay);
            this.el().append(bubbleEl);
            bubbleEl.onanimationend = () => this.el().contains(bubbleEl) && this.el().removeChild(bubbleEl);
        }
    }
}

Component.registerComponent('Bubbles', Bubbles);
